import React from 'react';
import Avatar from 'material-ui/Avatar';

export default function ProductAvatar(props) {
  const {
    src,
    name,
    style
  } = props;

  return (
    <Avatar
      style={style}
      size={40}
      src={src || null}
      >
        {src ? null : name.charAt(0)}
      </Avatar>
  );
}



// WEBPACK FOOTER //
// ./src/Product/ProductAvatar.js